import styled from 'styled-components';
import AbstractTextElement from 'UIComponents/elements/AbstractTextElement';
const BigText = styled(AbstractTextElement).withConfig({
  displayName: "BigText",
  componentId: "s2mtvh-0"
})(["&&{font-size:16px;line-height:28px;}"]);
export default BigText;